import { render, staticRenderFns } from "./UserTelephony.vue?vue&type=template&id=21f1466b&"
import script from "./UserTelephony.vue?vue&type=script&lang=js&"
export * from "./UserTelephony.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports